export const getFileIcon = (fileName: string): string => {
  const ext = fileName.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "pdf":
      return "📄";
    case "doc":
    case "docx":
      return "📝";
    case "jpg":
    case "jpeg":
    case "png":
      return "🖼️";
    case "zip":
      return "📦";
    case "csv":
      return "📊";
    case "xlsx":
    case "xls":
      return "📈";
    case "ppt":
    case "pptx":
      return "📺";
    case "txt":
      return "📝";
    default:
      return "📄";
  }
};
